import { request } from '../request'

export const brigadas = {
  getParadasBrigadas: function () {
    return request.get(`api/getParadaBrigadas?epsg=EPSG%3A4326`)
  }
}
